import { Table } from '@nimbus-ds/components';
import { CustomHeaderCell } from 'commons/components';
import useLocations from 'domains/Shipping/Locations/hooks/useLocations';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';
import LocationListBody from './components/LocationListBody';

interface LocationsListDesktopProps {
  openSetMainModal: (locationId: any) => void;
  openDeleteModal: (locationId: any) => void;
}

function LocationsListDesktop({
  openSetMainModal,
  openDeleteModal,
}: Readonly<LocationsListDesktopProps>): JSX.Element {
  const { locations, isLoading } = useLocations();
  const t = useTranslationShipping();

  return (
    <Table>
      <Table.Head>
        <CustomHeaderCell width="70px">
          {t('locations.headers.priority')}
        </CustomHeaderCell>
        <CustomHeaderCell width="20%">
          {t('locations.headers.name')}
        </CustomHeaderCell>
        <CustomHeaderCell width="auto">
          {t('locations.headers.address')}
        </CustomHeaderCell>
        <CustomHeaderCell width="20%">
          {t('locations.headers.tags')}
        </CustomHeaderCell>
        <CustomHeaderCell width="145px">
          {t('locations.headers.actions')}
        </CustomHeaderCell>
      </Table.Head>
      {isLoading ? (
        <LocationListBody.Skeleton />
      ) : (
        <LocationListBody
          locations={locations}
          openSetMainModal={openSetMainModal}
          openDeleteModal={openDeleteModal}
        />
      )}
    </Table>
  );
}

export default LocationsListDesktop;
